import React from "react";
import { Text } from "nectar-ui";
import { ListCard } from "@components/styles/dataDisplay";
import Skeleton from "react-loading-skeleton";
import { CustomSkeleton } from "./style";
import {
  ButtonContainer,
  LawsuitItemBody,
  LawsuitItemContainer,
  LawsuitItemHeaderContainer,
} from "@components/pages/lawsuit/styles";
import { FaRegFolder } from "@react-icons/all-files/fa/FaRegFolder";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";

const LawsuitListItemSkeleton = () => {
  const NUMBER_SKELETONS = 3;

  const skeletons: React.ReactElement[] = [];
  for (let index = 1; index <= NUMBER_SKELETONS; index++) {
    const skeleton = (
      <LawsuitItemContainer key={index}>
        <LawsuitItemBody>
          <LawsuitItemHeaderContainer>
            <FaRegFolder size={16} />
            <div style={{ flex: 1 }}>
              <CustomSkeleton marginBottom={false} height={24} />
            </div>
          </LawsuitItemHeaderContainer>
          <Text noMargin>
            <Skeleton width={216} height={16} />
          </Text>
          <Text noMargin>
            <Skeleton width={216} height={16} />
          </Text>
        </LawsuitItemBody>
        <ButtonContainer>
          <CustomSkeleton marginBottom={false} height={38} />
        </ButtonContainer>
      </LawsuitItemContainer>
    );

    skeletons.push(skeleton);
  }

  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading noMargin>Processos e casos</CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            Encontre todos os seus processos e casos e escolha um deles para ver mais detalhes.
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>
      <div>
        <Text margin="xs">
          <Skeleton width={216} height={14} />
        </Text>

        <ListCard border>{skeletons}</ListCard>
      </div>
    </div>
  );
};

export default LawsuitListItemSkeleton;
